module.exports = __webpack_public_path__ + "static/media/markel.63a06880.webp";